export function safeEnumValue(enumData, key) {
    if (!(key in enumData)) {
        throw new Error(`Enum key "${key?.toString()}" does not exist`);
    }
    return enumData[key];
}
/**
 * List enum keys. It works for string and number enum where Object.keys will returns both key and values.
 *
 * ```typescript
 * enum EnumString {
 *  A = 'MyValueA',
 *  B = 'MyValueB
 * }
 *
 * expect(listEnumKeys(EnumString)).to.be.eq(['A', 'B']);
 * expect(Object.keys(EnumString)).to.be.eq(['A', 'B', 'MyValueA', 'MyValueB']);
 * ```
 * @param enumType
 */
export function listEnumKeys(enumType) {
    if (typeof enumType !== 'object' || enumType === null) {
        return [];
    }
    let keys = Object.keys(enumType);
    keys = keys.filter((k) => {
        if (typeof enumType[k] === 'number') {
            return true;
        }
        return (isNaN(parseInt(k, 10)) && isNaN(parseInt(enumType[k], 10)));
    });
    if (keys.length === 0) {
        keys = Object.keys(enumType);
    }
    return keys;
}
/**
 * List enum values
 * @param enumType
 */
export function listEnumValues(enumType) {
    return listEnumKeys(enumType).map((v) => enumType[v]);
}
